export default [
    {
      title: 'menu.Payments',
      icon: 'CreditCardIcon',
      tagVariant: 'light-danger',
      route:'payments'
    },
  ]
  